export const ROLE_LABELS = { admin: "Admin", senior_medic: "Senior Medic", staff: "Staff" };

export const OUTCOME_LABELS = {
  returned_to_event: "Returned to event",
  left_scene: "Left scene (own accord)",
  taken_to_hospital: "Taken to hospital",
  refused_care: "Refused care / self-discharged",
  other: "Other",
};

export const RISK_STYLES = {
  high: "bg-red-100 text-[#D5281B] border-red-300",
  medium: "bg-amber-100 text-[#ED8B00] border-amber-300",
  low: "bg-emerald-100 text-[#007F3B] border-emerald-300",
};

const TRIAGE_STYLES = {
  high: "bg-red-100 text-[#D5281B] border-red-200",
  medium: "bg-amber-100 text-[#ED8B00] border-amber-200",
  low: "bg-emerald-100 text-[#007F3B] border-emerald-200",
};
const TRIAGE_LABELS = { high: "High Priority", medium: "Monitor", low: "Stable" };

export function TriageBadge({ triage }) {
  return (
    <span className={`inline-flex items-center px-2.5 py-1 rounded-full text-[11px] font-bold border ${TRIAGE_STYLES[triage] || TRIAGE_STYLES.low}`} data-testid={`triage-badge-${triage}`}>
      {TRIAGE_LABELS[triage] || "Stable"}
    </span>
  );
}

export function fmt(dt) {
  if (!dt) return "";
  const d = new Date(dt);
  return `${d.toLocaleDateString("en-GB")} ${d.toLocaleTimeString("en-GB", { hour: "2-digit", minute: "2-digit" })}`;
}

export function ageFromDob(dob) {
  if (!dob) return null;
  const d = new Date(dob);
  if (isNaN(d)) return null;
  const diff = Date.now() - d.getTime();
  return Math.floor(diff / (365.25 * 24 * 3600 * 1000));
}

export function Vital({ label, value, unit }) {
  if (value == null || value === "") return null;
  return (
    <div className="bg-[#0B192C] rounded-lg px-3 py-2.5">
      <p className="text-[10px] font-semibold uppercase tracking-wider text-slate-400">{label}</p>
      <p className="font-vitals text-xl font-extrabold text-[#38BDF8] tracking-wider">
        {value}<span className="text-xs text-slate-400 ml-1">{unit}</span>
      </p>
    </div>
  );
}
